
import { supabase } from "@/integrations/supabase/client";

export const getSubordinateIds = async (supervisorId: string): Promise<string[]> => {
  try {
    const { data, error } = await supabase
      .rpc('get_user_subordinates', { supervisor_uuid: supervisorId });
    
    if (error) {
      console.error("Error fetching subordinates:", error);
      return [];
    }
    
    return data ? data.map((row: any) => row.subordinate_id) : [];
  } catch (error) {
    console.error("Error in getSubordinateIds:", error);
    return [];
  }
};
